// extracted by mini-css-extract-plugin
export default {"p_content":"_95f0f5f0d6"};